import {UseFormReturn} from "react-hook-form";
import {Grid} from "@mui/material";
import {LabeledInput} from "../base/LabeledInput";
import {CheckboxInput} from "../base/CheckboxInput";
import {useTranslation} from "react-i18next";

export interface CompanyAdminPreferencesFormInputs {
    isReseller: boolean;
    isApiEnabled: boolean;
    includeChildCompanies?: boolean;
}

export interface Props {
    initFormValues: CompanyAdminPreferencesFormInputs;
    form: UseFormReturn<CompanyAdminPreferencesFormInputs>;
}

export const CompanyAdminPreferencesForm: React.FC<Props> = ({initFormValues, form: {control}}) => {
    const {t} = useTranslation();
    return (
        <Grid item xs={12}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <LabeledInput label={t("companies.admin_preferences_form.reseller")}>
                        <CheckboxInput
                            name="isReseller"
                            control={control}
                            initialValue={initFormValues.isReseller}
                            label={t("companies.admin_preferences_form.reseller_label")}
                            inputProps={{sx: {marginTop: "0.25rem"}}}
                        />
                    </LabeledInput>
                </Grid>
                <Grid item xs={6}>
                    <LabeledInput label={t("companies.admin_preferences_form.api")}>
                        <CheckboxInput
                            name="isApiEnabled"
                            control={control}
                            initialValue={initFormValues.isApiEnabled}
                            label={t("companies.admin_preferences_form.api_label")}
                            inputProps={{sx: {marginTop: "0.25rem"}}}
                        />
                    </LabeledInput>
                </Grid>
                <Grid item xs={6}>
                    <LabeledInput label={t("companies.admin_preferences_form.child_companies")}>
                        <CheckboxInput
                            name="includeChildCompanies"
                            control={control}
                            initialValue={initFormValues.includeChildCompanies}
                            label={t("companies.admin_preferences_form.show_child_companies")}
                            inputProps={{sx: {marginTop: "0.25rem"}}}
                        />
                    </LabeledInput>
                </Grid>
            </Grid>
        </Grid>
    );
};
